import React from 'react'
import styled from 'styled-components';
import { Link } from 'gatsby';

const Index = () => {

  const getPathnames = () => {
    if (typeof window !== 'undefined') {
      return window.location.pathname.split('/').filter((x) => x && isNaN(x));
    }
    return [];
  };

  const pathnames = getPathnames();
  const breadcrumbs = [
    { path: '/', label: 'Home' },
    ...pathnames.map((value, index) => ({
      path: `/${pathnames.slice(0, index + 1).join('/')}`,
      label: value.replace(/-/g, ' ').charAt(0).toUpperCase() + value.replace(/-/g, ' ').slice(1),
    })),
  ];

  return (
    <NavigationWrapper>
      <BreadcrumbWrapper>
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={breadcrumb.path}>
            {index > 0 && <Separator>/</Separator>}
            <Breadcrumb to={breadcrumb.path}>
              {breadcrumb.label}
            </Breadcrumb>
          </React.Fragment>
        ))}
      </BreadcrumbWrapper>
    </NavigationWrapper>
  )
}

export default Index

const NavigationWrapper = styled.div`
  margin-top:24px;
  @media (min-width: 1200px) {
    margin-bottom:-24px;
  }
`

const BreadcrumbWrapper = styled.div`
  display:flex;
  align-items: center;
  gap: 5px;
  font-family: 'Poppins';
  color: white;
  font-size: 10px;
`

const Breadcrumb = styled(Link)`
  font-size: 16px;
  font-weight: 300;
  text-transform: uppercase;
  text-decoration: none;
  position: relative;
  color: white;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 2px;
    background-color: #F19D9A;
  }
`

const Separator = styled.span`
  color: white;
  margin: 0 5px;
`
